import React from "react";
import { months } from "../../utils/rawData/dateValues";

const ItemRowConciliacionResumen = ({r, i, headers, headersTableActive}) => {
  
  const formatCurrency = (value) => {
    return value.toLocaleString("es-PE", { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    });
  };

  return (
    <>
      {headers.map((header) => (
        <td key={header.id} className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">  
          {header.content === "month" ? (
            months[r[header.content] - 1]?.label
          ) : header.content.includes("Ingresos") || header.content.includes("Egresos") || header.content.includes("Balanza") || header.content.includes("SaldoNeto") ? (
            <span className={r[header.content] >= 0 ? "text-green-600" : "text-red-600"}>
              S/ {formatCurrency(r[header.content] || 0)}
            </span>
          ) : (
            r[header.content]
          )}
        </td>
      ))}
    </>
  )
}

export default ItemRowConciliacionResumen;
